import { TabsProps } from 'antd';
import { useProcContext } from '@/entities/proc';
import { Tabs } from '../tabs';
import { ImageUpload } from './ImageUpload';
import { ImageUrl } from './ImageUrl';

enum TabKeys {
  Upload = 'upload',
  ImageUrl = 'imageUrl',
}

const items: TabsProps['items'] = [
  {
    key: TabKeys.Upload,
    label: `Upload`,
    children: <ImageUpload />,
  },
  {
    key: TabKeys.ImageUrl,
    label: `Image URL`,
    children: <ImageUrl />,
  },
];

export const ImageInput = () => {
  const { proc } = useProcContext();
  return (
    <Tabs
      data-testid="image-input-tabs"
      defaultActiveKey={proc?.imageLink ? TabKeys.ImageUrl : TabKeys.Upload}
      items={items}
    />
  );
};
